import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_pos-r _ml-1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_click_outside = _resolveComponent("click-outside")

  return (_openBlock(), _createElementBlock("div", {
    class: "_flex",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.primaryActions, (action, index) => {
      return (_openBlock(), _createBlock(_component_tooltip, {
        key: index,
        text: action.label,
        class: "_flex _ml-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            shape: "circle",
            theme: $options.getTheme(action.theme),
            enabled: $options.getEnabledStatus(action.enabled),
            onClick: _withModifiers(action.fn, ["stop"]),
            "data-qa": `context-action:${action.qa}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: action.iconName
              }, null, 8 /* PROPS */, ["name"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["theme", "enabled", "onClick", "data-qa"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"]))
    }), 128 /* KEYED_FRAGMENT */)),
    ($options.hasSecondaryActions)
      ? (_openBlock(), _createBlock(_component_click_outside, {
          key: 0,
          call: $options.onBalloonClose
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_base_button, {
                ref: "trigger",
                shape: "circle",
                theme: $props.defaultButtonTheme,
                onClick: _withModifiers($options.onBalloonToggle, ["stop"]),
                "data-qa": `context-action:Open`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_icon, { name: "ellipsis-v" })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["theme", "onClick"]),
              (_ctx.isSecondaryActionVisible)
                ? (_openBlock(), _createBlock(_component_base_balloon, _mergeProps({ key: 0 }, $props.balloonProps, {
                    anchor: "fixed",
                    direction: _ctx.direction,
                    position: "center",
                    "show-header": false,
                    style: $options.balloonStyles,
                    "data-qa": "context-action-balloon:Content"
                  }), {
                    content: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.secondaryActions, (action, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "gfu-balloon__content-link",
                          onClick: $event => ($options.onBalloonAction(action.fn))
                        }, [
                          _createVNode(_component_base_icon, {
                            name: action.iconName,
                            class: "gfu-balloon__content-icon"
                          }, null, 8 /* PROPS */, ["name"]),
                          _createElementVNode("span", {
                            "data-qa": `context-action-link:${action.qa}`
                          }, _toDisplayString(action.label), 9 /* TEXT, PROPS */, _hoisted_3)
                        ], 8 /* PROPS */, _hoisted_2))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["direction", "style"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["call"]))
      : _createCommentVNode("v-if", true)
  ]))
}